module.exports = __webpack_public_path__ + "img/stamo-icon.142f60af.png";